import { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

import "./style.css";
import Request from "../button/Request";
import FaqSection from "../Accordion/Accordion";
import { BlogApi } from "../../api/blog";

const TrustCenter = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const { data } = await BlogApi({ page: 1, limit: 5 });
        if (data?.status) {
          const formattedData = data?.data?.blogs?.map((item) => ({
            id: item?.id,
            title: item?.title,
            desc: item?.desc,
            image: item?.image,
            created_at: new Date(item?.date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }),
          }));
          setBlogs(formattedData || []);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchBlogs();
  }, []);
   const FAQData = [
     {
      question: "Store client and prospect information",
      answer:
        "Gather valuable insights about your clients and leverage that data to serve them better. With a top-tier CRM solution for small businesses, you can centralize all client and prospect information in a single hub, significantly enhancing the efficiency and effectiveness of your client servicing.",
    },
    {
      question: "Simplified account management",
      answer:
        "Consolidate your company's leads and clients on a unified dashboard. Configure your CRM hub with client-centric workflows, unlimited contacts, custom fields, tags, filters, and bulk actions. Our AI-powered platform helps you establish clear links between contacts and accounts to build and track relationships seamlessly.",
    },
    {
      question: "End-to-end management control",
      answer:
        "TrackmyDoc is your single point of control for organizing and automating accounting, payroll, and bookkeeping processes. Manage client communication, the intake process, task creation, scheduling, billing, engagement letters, and custom CRM templates—all executed swiftly and flawlessly with minimal intervention required.",
    },
    {
      question: "Onboard clients in a snap",
      answer:
        "Use our powerful CRM software to save your team time and serve more clients efficiently. AI-powered automation facilitates smooth new client onboarding. From capturing a lead via a personalized login page to e-signing completed files, we make the entire process simple and quick.",
    },
    {
      question: "Automated reminders",
      answer:
        "Automate reminders to keep your clients on track without manual intervention. Eliminate tedious follow-ups; instead, use automation to promptly notify clients about pending organizers, invoices, contracts, messages, approvals, signatures, and file requests. This integrated approach, featuring e-signature software, billing solutions, and recurring invoicing, saves hours of manual work while boosting client engagement.",
    },
  ];
  return (
    <div>
      {/* Hero Section */}
      <div className="hero-section py-sm-5 py-3">
        <div className="website-container">
          <div className="__text text-center">
            <h2 className="mb-12">
              <span className="primary-color">TMD</span> Trust Center
            </h2>
            <p className="f-18 mx-707">
              Explore our resources to learn how we safeguard client data. We
              prioritize security by implementing industry best practices and
              continuously monitoring our systems to meet all compliance
              standards.
            </p>
          </div>
        </div>
      </div>

      {/* How TMD approaches security */}
      <div className="tc-approach-section">
        <div className="tc-approach-top">
          <div className="website-container">
            <h2 className="text-center mb-0 text-white">
              How <span className="primary-color">TMD</span> approaches security
            </h2>
          </div>
        </div>
        <div className="pb-4">
          <div className="website-container">
            <Row className="g-4 justify-content-center tc-cards-row">
              <Col xs={12} md={6} lg={3}>
                <div className="tc-card">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="/tc-icon1.svg"
                      alt="Privacy"
                      className="tc-card-icon me-3"
                    />
                    <h5 className="mb-0 text-lg fw-600">Privacy</h5>
                  </div>
                  <p>
                    We ensure strong security processes in both our product and
                    working environment, aligning people, processes, and
                    technology.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={3}>
                <div className="tc-card">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="/tc-icon2.svg"
                      alt="Security"
                      className="tc-card-icon me-3"
                    />
                    <h5 className="mb-0 text-lg fw-600">Security</h5>
                  </div>
                  <p>
                    We ensure strong security processes in both our product and
                    working environment, aligning people, processes, and
                    technology.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={3}>
                <div className="tc-card">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="/tc-icon3.svg"
                      alt="Compliance"
                      className="tc-card-icon me-3"
                    />
                    <h5 className="mb-0 text-lg fw-600">Compliance</h5>
                  </div>
                  <p>
                    We ensure strong security processes in both our product and
                    working environment, aligning people, processes, and
                    technology.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={3}>
                <div className="tc-card">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="/tc-icon4.svg"
                      alt="Status"
                      className="tc-card-icon me-3"
                    />
                    <h5 className="mb-0 text-lg fw-600">Status</h5>
                  </div>
                  <p>
                    We ensure strong security processes in both our product and
                    working environment, aligning people, processes, and
                    technology.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Certifications and attestations */}
      <div className="tc-cert-section">
        <div className="tc-cert-top">
          <div className="website-container">
            <div className="text-center">
              <h2 className="mb-12">Certifications and attestations</h2>
              <p className="mx-707 mx-auto">
                axDome complies with global privacy laws and security standards,
                implementing measures to help you fulfill your compliance
                obligations.
              </p>
            </div>
          </div>
        </div>
        <div className="tc-cert-bottom">
          <div className="tc-cert-border">
            <div className="website-container">
              <Row className="justify-content-center tc-cert-row">
                <Col xs={12} md={4} className="text-center">
                  <div className="tc-cert-item">
                    <div className="tc-cert-img-wrap">
                      <img
                        src="/certificate1.svg"
                        alt="GDPR"
                        className="tc-cert-img"
                      />
                    </div>
                    <h5 className="mb-0 text-lg fw-600">GDPR</h5>
                    <p className="mx-auto">
                      We prioritize your privacy by implementing robust security
                      measures to protect your data. See how we manage your data
                      and customer information in our privacy policy.
                    </p>
                  </div>
                </Col>
                <Col xs={12} md={4} className="text-center">
                  <div className="tc-cert-item">
                    <div className="tc-cert-img-wrap">
                      <img
                        src="/certificate2.svg"
                        alt="ISO/IEC 27001"
                        className="tc-cert-img"
                      />
                    </div>
                    <h5 className="mb-0 text-lg fw-600">ISO/IEC 27001</h5>
                    <p className="mx-auto">
                      We prioritize your privacy by implementing robust security
                      measures to protect your data. See how we manage your data
                      and customer information in our privacy policy.
                    </p>
                  </div>
                </Col>
                <Col xs={12} md={4} className="text-center">
                  <div className="tc-cert-item">
                    <div className="tc-cert-img-wrap">
                      <img
                        src="/certificate3.svg"
                        alt="PIPEDA"
                        className="tc-cert-img"
                      />
                    </div>
                    <h5 className="mb-0 text-lg fw-600">PIPEDA</h5>
                    <p className="mx-auto mb-0">
                      We prioritize your privacy by implementing robust security
                      measures to protect your data. See how we manage your data
                      and customer information in our privacy policy.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-section pattern-line2 lg:pt-16 pt-12">
        <div className="__text text-center res-mb-40 mt-0">
          <h1 className="mb-12 leading-normal text-[40px] max-xl:text-[27px] max-md:text-[20px]">
            The most effective platform for <br />
            <span className="primary-color mt-2">
              CPAs, Insurance Agents, and Immigration Consultants.
            </span>
          </h1>
          <p className="f-18 mb-20">
            Empower and manage your teams with an AI-powered CRM platform.
          </p>
          <div className="flex justify-center gap-4">
            <Request />
            {/* <button className="btn btn-outline-primary">
                    Start Free Trial
                  </button> */}
          </div>
        </div>
      </div>
      {/* Blogs Section */}
      {blogs.length > 0 && (
        <div className="tc-blogs-section">
          <div className="website-container">
            <div className="pb-xl-5 pb-lg-4 pb-3 tc-blogs-header text-center">
              <h2 className="text-white mb-12">Blogs</h2>
              <p className="text-white mx-auto" style={{ opacity: 0.7 }}>
                Learn more about our security approach.
              </p>
            </div>
            <div className="tc-blogs-slider-wrap">
              <Slider
                {...{
                  dots: false,
                  arrows: true,
                  infinite: false,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  speed: 500,
                  autoplay: true,
                  autoplaySpeed: 3000,
                  prevArrow: (
                    <button type="button" className="slick-prev">
                      <img src="/left-arrow.png" alt="Previous" className="tc-slider-arrow-img" />
                    </button>
                  ),
                  nextArrow: (
                    <button type="button" className="slick-next">
                      <img src="/right-arrow.png" alt="Next" className="tc-slider-arrow-img" />
                    </button>
                  ),
                  responsive: [
                    {
                      breakpoint: 991,
                      settings: {
                        slidesToShow: 2,
                      },
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 1,
                      },
                    },
                  ],
                }}
              >
                {blogs.map((item) => (
                  <div key={item.id} className="px-2">
                    <div className="tc-blog-card">
                      <div className="tc-blog-img-wrap">
                        <img src={item.image || "/blog.png"} alt="Blog" className="tc-blog-img" />
                      </div>
                      <div className="tc-blog-content">
                        <h5 className="fw-600 mb-2">
                          {item.title}
                        </h5>
                        <p className="tc-blog-desc">
                          <span dangerouslySetInnerHTML={{ __html: item.desc }} />
                          <Link to={`/blog/${item.id}`} className="primary-color fw-600">
                            Read More
                          </Link>
                        </p>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="tc-blog-date">{item.created_at}</span>
                          <Link to={`/blog/${item.id}`}>
                            <img src="/topright-arroe.png" alt="arrow" className="tc-blog-arrow-img" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      )}
        <FaqSection
        data={FAQData}
        subTitle="Your concerns, answered"
        Title="Frequently asked questions"
      />
      {/* Get Help CTA Section */}
      <div className="tc-cta-section">
        <div className="website-container">
          <div className="d-flex flex-lg-row flex-column align-items-center justify-content-between flex-wrap">
            <div className="d-flex flex-lg-row flex-column align-items-center justify-content-center text-center text-lg-start mb-2 mb-lg-0">
              <img src="/cta-icon.svg" alt="Support" className="tc-cta-icon me-4 mb-3" />
              <div>
                <h2 className="text-white fw-700 mb-3">Get help on Trust Center usage</h2>
                <p className="text-white mb-0 tc-cta-desc">
                  If you need help using the Trust Center or want to learn more about
                  our security measures, please contact our Support Team.
                </p>
              </div>
            </div>
            <Link to="/contact" className="tc-cta-btn">
              Contact Support
            </Link>
          </div>
        </div>
      </div>

          
    </div>
  );
};

export default TrustCenter;
